var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ml-auto white--text",attrs:{"fab":"","x-small":"","color":"blue-grey darken-1","elevation":"1"},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v("mdi-close-thick")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }